import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from '../../Footer';
import Spinner from '../../common/components/Spinner';

const Layout = () => {
    return (
        <main className='App' style={{ color: "white", backgroundColor: "#6B747F", minHeight: "100vh" }}>
            <React.Fragment>                
                <table width={"100%"}>
                    <tbody>
                        {/* CABEÇALHO */}
                        <tr>
                            <td><Header /></td>
                        </tr>

                        {/* ÁREA DINÂMICA (Onde abre o Dashboard) */}
                        <tr>
                            <td style={{ verticalAlign: "top", paddingTop: "30px", paddingBottom: "50px" }}>
                                <div style={{ padding: 10, color: "white", backgroundColor: "#6B747F", display: 'flex', justifyContent: 'center' }}>
                                    {/* É aqui que o BOTablesDashboard.js vai ser injetado */}
                                    <Outlet /> 
                                </div>
                            </td>
                        </tr>

                        {/* RODAPÉ */}
                        <tr>
                            <td><Footer /></td>
                        </tr>
                    </tbody>
                </table>
                <Spinner />
            </React.Fragment>
        </main>
    );
};

export default Layout;